export const STREETS_SMART_API_LOADED = 'STREETS_SMART_API_LOADED'
export const CYCLORAMA_LOADING = 'CYCLORAMA_LOADING'
export const RESET_DATA = 'RESET_DATA'



// WEBPACK FOOTER //
// ./src/store/actionTypes/CycloramaActionTypes.js